import axios from './axios'

export async function getEmergencyContact(id: number) {
    const response = await axios.get(`/api/emergenzaGet/${id}`);
    return response.data;
}

export async function getMoreContacts(id: number) {
    const response = await axios.get(`/api/moreContactsGet/${id}`);
    return response.data;
}